import React, { useState, useEffect } from "react";

export default function PortalLayer({ portals, camX, camY, onPortalClick }) {
  const [animationFrame, setAnimationFrame] = useState(0);

  // Portal animation - cycle through 4 frames
  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationFrame((prev) => (prev + 1) % 4);
    }, 250); // Change frame every 250ms for smooth animation

    return () => clearInterval(interval);
  }, []);

  if (!portals || portals.length === 0) return null;

  return (
    <>
      {portals.map((portal, index) => {
        const screenX = portal.x - camX;
        const screenY = portal.y - camY;
        
        return (
          <div
            key={`portal-${index}`}
            className="portal"
            style={{
              position: "absolute",
              left: screenX,
              top: screenY,
              width: 64,
              height: 64,
                    // Semi-transparent background to make clickable area visible
              backgroundImage: "url('/Maps/Portal.png')",
              backgroundPosition: `-${animationFrame * 64}px 0px`,
              backgroundSize: "256px 64px", // Total width of sprite sheet x height
              backgroundRepeat: "no-repeat",
              cursor: "pointer",
              zIndex: 100, // Very high z-index to ensure it's above everything
              filter: "drop-shadow(0 0 15px #9400D3)", // Stronger purple glow effect
              pointerEvents: "auto", // Ensure it catches click events
            }}
            onClick={() => onPortalClick(portal)}
          />
        );
      })}
    </>
  );
}
